
import { redirect } from 'react-router-dom';

import store from "config/redux/index";
import { error, setDialogError } from 'config/redux/slice';
import { AppConstants, RouteConstants } from 'constant';
import { ServiceModel } from 'models';
import { AppUtils, CryptoUtils } from 'utils';

import * as PublicService from './public';

const { SUPPORTED_ERRORS_CODES } = AppConstants;
const SECRET_KEY = process.env.REACT_APP_AES_KEY;
const { ROUTE_LOGIN } = RouteConstants;

export async function handleErrorWithTokenRenewal(error: any, method: any, methodParams: any[], serviceId: string) {
  const err = JSON.parse(JSON.stringify(error));
  console.log('[API ERROR]', error);
  if (err?.status === 401) {
    try {
      const renewResponse = await PublicService.renew();
      if (renewResponse) {
        setTimeout(() => method(...methodParams), 250);
        return;
      }
      if (window.location.pathname !== ROUTE_LOGIN) {
        AppUtils.logout();
        redirect(ROUTE_LOGIN);
        return;
      }
    } catch (renewError) {
      if (window.location.pathname !== ROUTE_LOGIN) {
        AppUtils.logout();
        redirect(ROUTE_LOGIN);
      }
    }
  } else {
    handleServiceError(serviceId, error);
  }
}

export function handleServiceError(serviceId: string, err: any) {
  const { status, code, response } = err;
  if (status === 400 && response) {
    if (!!response.data && !!SECRET_KEY && !response.config.headers['X-Encrypted'] && !(response.data instanceof Blob)) {
      response.data = CryptoUtils.decrypt(response.data);
    }
    store.dispatch(error(new ServiceModel(serviceId, response.data)));
    if (response.data.code && response.data.message) {
      store.dispatch(setDialogError(response));
    }
    return;
  } else if (SUPPORTED_ERRORS_CODES.includes(status)) {
    errorRedirect(status);
  } else if (code === 'ERR_NETWORK') {
    errorRedirect(503);
  } else if (code === 'ERR_BAD_RESPONSE') {
    errorRedirect(500);
  }
  store.dispatch(error(new ServiceModel(serviceId, err)));
}

function errorRedirect(status: number) {
  redirect("/error/" + status);
}
